module.exports = __webpack_public_path__ + "img/20190617162632051.2a943ae9.png";